module.exports = __webpack_public_path__ + "img/kgct-log.fc82f200.png";